export default __webpack_public_path__ + "static/katie_koschland-3b2080913b81c1eafe4fd1e50a030873.jpg";